import React from 'react';
import { BasicTable } from '@utriper/core-ui';
import { Grid2 } from '@mui/material';

const ResourceTable = ({ resources, openModal, ...props }) => {
    const columns = [
        {
            val: 'name',
            label: 'Nombre',
            column: 'name',
        },
        { val: 'mobilePhone', label: 'Phone', column: 'mobilePhone' },
        { val: 'email', label: 'Email', column: 'email' },
        {
            val: 'createdOnFormatted',
            label: 'Creado',
            column: 'createdOnFormatted',
        },
        {
            val: 'categoryName',
            label: 'Categoria',
            column: 'categoryName',
        },
    ];

    const onClick = (event, id) => {
        openModal(event, id);
    };

    return (
        <Grid2>
            <BasicTable columns={columns} values={resources} onClick={(event, id) => onClick(event, id)} />
            <br />
        </Grid2>
    );
};
export default ResourceTable;
